
































import { Component, Vue, Prop } from "vue-property-decorator";
import { getCityList } from "../api/cjDetail";
@Component
export default class position extends Vue {
  @Prop({}) cityName!: any;

  cityList: any[] = [];
  indexList: any[] = [];
  mounted() {
    this.getCityData();
  }
  getCityData() {
    let params: any = {};
    getCityList(params).then((res: any) => {
      //返回值
      this.cityList = res.data;
      for (let i in this.cityList) {
        this.indexList.push(this.cityList[i].letter);
      }
    });
  }
  selectCity(params: any, item: any) {
    if (!params) {
      this.$emit("getSelectCity", "");
    } else {
      this.$emit("getSelectCity", item);
    }
  }
}
